var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74461 11.9143C8.74461 12.6107 7.99077 13.0459 7.3877 12.6977C6.78461 12.3495 6.78461 11.4791 7.3877 11.1309C7.52521 11.0515 7.68121 11.0097 7.84 11.0097C8.33961 11.0097 8.74461 11.4147 8.74461 11.9143ZM7.84 3.77276C6.17701 3.77276 4.82461 4.99022 4.82461 6.4866V6.78814C4.82461 7.25239 5.32718 7.54255 5.72923 7.31042C5.91583 7.2027 6.03077 7.0036 6.03077 6.78814V6.4866C6.03077 5.65737 6.84266 4.97891 7.84 4.97891C8.83734 4.97891 9.64923 5.65737 9.64923 6.4866C9.64923 7.31583 8.83734 7.9943 7.84 7.9943C7.50692 7.99428 7.23693 8.26429 7.23693 8.59737V9.20045C7.23693 9.6647 7.73949 9.95485 8.14154 9.72273C8.32813 9.615 8.44308 9.41591 8.44308 9.20045V9.14617C9.8181 8.89363 10.8554 7.79679 10.8554 6.4866C10.8554 4.99022 9.50298 3.77276 7.84 3.77276ZM15.68 7.9943C15.68 14.0295 9.14667 17.8016 3.92 14.7839C-1.30667 11.7663 -1.30667 4.22227 3.92 1.20466C5.11183 0.516553 6.4638 0.154297 7.84 0.154297C12.168 0.158872 15.6754 3.66628 15.68 7.9943ZM14.4738 7.9943C14.4738 2.88756 8.94565 -0.304153 4.52308 2.24922C0.100514 4.80258 0.100514 11.186 4.52308 13.7394C5.53155 14.3216 6.67552 14.6281 7.84 14.6281C11.5021 14.624 14.4697 11.6563 14.4738 7.9943Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.334e5d80162e20a163226e3757ff5e34.svg";
export { ForwardRef as ReactComponent };